/* eslint-disable max-len */
import { useMemo } from 'react';
import { useEcomStoreSelector } from '@/data';
import { TreezClient, useTreezClient } from '../api';
export class MenuService {
  private _client: TreezClient;

  constructor(client?: TreezClient) {
    this._client = client ?? new TreezClient();
  }

  checkIfProductsBelongsToStore = async (_products, _storeId) => {
    return {
      hasOutsideProducts: true, // TODO implement this feature using Treez API
    };
  };

  getInsideStoreProducts = async (_products, _storeId) => {
    return []; // TODO implement using the Treez API
  };

  getOutsideProducts = async (products, _storeId) => {
    return products; // TODO implement using the Treez API
  };
}

export const useMenuService = () => {
  const client = useTreezClient();
  const { customer_type, provider_inventory_location_id } =
    useEcomStoreSelector(['customer_type', 'provider_inventory_location_id']);

  const menuService = useMemo(
    () => new MenuService(client),
    [client, customer_type, provider_inventory_location_id],
  );

  return menuService;
};
